import { BREAKPOINTS } from '@ds/swymkit/utils'
import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_HOME } from '~/contexts/home/router/routes'

export const HOME_ROUTE_META = 'home'
export const HOME_ROUTE_FAVORITES_META = 'home-favorites'

const HOME_ROUTE: RouteRecordRaw = {
  name: ROUTE_HOME.HOME,
  path: '',
  component: () => import('~/contexts/home/pages/home/index/index.vue'),
  meta: {
    name: HOME_ROUTE_META,
  },
}

const HOME_ROUTE_FAVORITES: RouteRecordRaw = {
  name: ROUTE_HOME.HOME_FAVORITES,
  path: 'favorites',
  component: () => import('~/contexts/home/pages/home/index/favorites.vue'),
  meta: {
    name: HOME_ROUTE_FAVORITES_META,
  },
}

const HOME_ROUTES: RouteRecordRaw = {
  path: '/home',
  component: () => import('~/contexts/home/pages/home/index.vue'),
  children: [
    HOME_ROUTE,
    HOME_ROUTE_FAVORITES,
  ],
}

const LANDING_ROUTE: RouteRecordRaw = {
  name: ROUTE_HOME.LANDING,
  path: '',
  component: () => import('~/contexts/home/pages/index.vue'),
  beforeEnter(to, from, next) {
    // eslint-disable-next-line newline-per-chained-call
    if (useBreakpoints(BREAKPOINTS).isGreaterOrEqual('sm'))
      // Keep hash to not break to v2 to v3 url parsing !
      return next(() => ({ name: ROUTE_HOME.HOME }))
    next()
  },
  meta: {
    leftNavigation: false,
    name: 'index',
  },
}

export const LANDING_WIDGET_PROFILE_ROUTE: RouteRecordRaw = {
  name: ROUTE_HOME.LANDING_WIDGET_PROFILE,
  path: '/landing/widget-profile',
  component: () => import('~/contexts/home/pages/landing/widget-profile.vue'),
  meta: {
    name: 'landing',
    leftNavigation: false,
  },
}

const LANDING_WIDGET_CONTEN_READER_ROUTE: RouteRecordRaw = {
  ...LANDING_WIDGET_PROFILE_ROUTE,
  name: ROUTE_HOME.LANDING_WIDGET_CONTENT_READER,
  path: '/landing/widget-content-reader',
}

/** Register all community routes as child of "/community" namespace */
export function getRoutes() {
  return [
    HOME_ROUTES,
    LANDING_ROUTE,
    LANDING_WIDGET_PROFILE_ROUTE,
    LANDING_WIDGET_CONTEN_READER_ROUTE,
  ]
}
